import { render, staticRenderFns } from "./note-item-cell.vue?vue&type=template&id=24d45ae6"
import script from "./note-item-cell.vue?vue&type=script&lang=js"
export * from "./note-item-cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports